/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Add: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12 2C12.5523 2 13 2.44772 13 3V11H21L21.1025 11.0049C21.6067 11.0562 22 11.4823 22 12C22 12.5177 21.6067 12.9438 21.1025 12.9951L21 13H13V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H11V3C11 2.44772 11.4477 2 12 2Z'
      fill='currentColor'
    />
  </React.Fragment>
)
